// @flow
import actionKeys from './serviceAreaMapActionKeys';
import service from './serviceAreaMapService';

const getServiceArea = (serviceProviderId: string | number):
{|payload: Promise<Object>, type: string|} => ({
  type: actionKeys.GET_SERVICE_AREA,
  payload: Promise.all([
    service.getServiceArea(serviceProviderId),
    service.getAdvertisingArea(serviceProviderId),
  ]),
});

const searchCities = (query: string):
{|payload: {|data: string, promise: any|}, type: string|} => ({
  type: actionKeys.SEARCH_CITIES,
  payload: {
    data: query,
    promise: service.searchCities(query),
  },
});

const getCityDetails = (serviceProviderId: string | number, cityId: number):
{|payload: any, type: string|} => ({
  type: actionKeys.GET_CITY_DETAILS,
  payload: service.getCityDetails(serviceProviderId, cityId),
});

const setServiceArea = (serviceProviderId: string | number, postalCodes: string[]): {|
  meta: {|postalCodes: Array<string>, serviceProviderId: string | number|},
  payload: any,
  type: string,
|} => ({
  type: actionKeys.SET_SERVICE_AREA,
  payload: service.setServiceArea(serviceProviderId, postalCodes),
  meta: {
    serviceProviderId,
    postalCodes,
  },
});

const resetSetServiceArea = (): {|type: string|} => ({
  type: actionKeys.SET_SERVICE_AREA_RESET,
});

export default {
  getServiceArea,
  searchCities,
  getCityDetails,
  resetSetServiceArea,
  setServiceArea,
};



// WEBPACK FOOTER //
// ./src/app/common/service-area/serviceAreaMapActions.js